export const configKeys = {
    OUTAGES_OVERVIEW: 'outagesOverview',

    OUTAGE_TECHNOLOGY_IDS: 'technologyIds',
    OUTAGE_POWERPLANT_IDS: 'powerplantIds',
    OUTAGE_UNIT_IDS: 'unitIds',
}
